<h2 mat-dialog-title class="title" i18n>Generate Application Config</h2>
<mat-dialog-content>
  <form>
    <div class="sub-title" i18n>Config file selected:</div>
    <div class="file-name">{{ data.file }}</div>
    <div class="sub-title" i18n>Choose Fasta File</div>
    <div>
      <app-dropdown
        [label]="dropdownLabel"
        [options]="dropdownOptions"
        (selectedValueChange)="handleValueChange($event)"
        [selectedValue]="selectionValue"
        [formControlObj]="selectFastaFileCntrl"
      ></app-dropdown>
    </div>
    <mat-error *ngIf="isErrorVisible" i18n>{{ errorMessage }}</mat-error>
    <div class="sub-title" i18n>Application</div>
    <div>
      <app-dropdown
        [label]="versionDropdownLabel"
        [options]="versionDropdownOptions"
        (selectedValueChange)="handleVersionChange($event)"
        [formControlObj]="selectVersionCntrl"
      ></app-dropdown>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <app-buttons
    [isDisabled]="false"
    [name]="cancelBtnLabel"
    [buttonType]="'mat-button'"
    [buttonStyle]="'btn-text'"
    (buttonClickEvent)="closePopup()"
  >
  </app-buttons>

  <app-buttons
    [isDisabled]="selectFastaFileCntrl.invalid || isErrorVisible || isSubmitting"
    [name]="doneBtnLabel"
    [buttonType]="'mat-flat-button'"
    [buttonStyle]="
      selectFastaFileCntrl.invalid || isErrorVisible || isSubmitting ? 'btn-filled-small-disabled' : 'btn-filled-small'
    "
    (buttonClickEvent)="onSubmit()"
  >
  </app-buttons>
</mat-dialog-actions>
